// extracted by mini-css-extract-plugin
export default {"dialogTitle":"FormDialog_dialogTitle__3MjH1","logo":"FormDialog_logo__CAxUB"};